import {RouteObject} from 'react-router-dom';

export const appAdminRoutes: RouteObject[] = [
  {
    path: 'oauth-applications',
    lazy: () => import('./app-admin-routes.lazy').then(m => ({Component: m.OAuthClientsPage}))
  },
  {
    path: 'coupons',
    lazy: () => import('@app/admin/coupons/coupons-index-page').then(m => ({Component: m.CouponsIndexPage})),
  },
  {
    path: 'coupons/new',
    lazy: () => import('@app/admin/coupons/create-coupon-page').then(m => ({Component: m.CreateCouponPage})),
  },
  {
    path: 'coupons/:couponId/edit',
    lazy: () => import('@app/admin/coupons/edit-coupon-page').then(m => ({Component: m.EditCouponPage})),
  },
];
